module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Map/Marker#2-72f030fb25c23c6e23523c878a4376c1.svg";